/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import {
  CarePlanFrequency,
  Manifest,
  DocLink,
  Hope,
  Bereavement,
  VisitLog,
  VisitSummary,
  Incidents,
} from '@mummssoftware/utils/constants';
import { isSmallTouchDevice, safariDetect } from '@mummssoftware/utils/web';

const isIPad = isSmallTouchDevice();

export const MenuWrapper = styled.div``;
// docLink
export const DocLinkBody = styled.div<{
  smallWidget?: boolean;
}>`
  position: relative;
  overflow: hidden;
  ${(props) =>
    props.smallWidget
      ? `height: 279px;
         background-color: ${props.theme.palette.background.paper};`
      : ''}
`;

export const DashboardMain = styled.div`
  display: flex;
  width: 100%;
`;
// WHY DOES @ page margin not work
export const DashboardPrintDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media print {
    font-family: 'auto', sans-serif;
    color: black !important;
    background-color: #ffffff;
    overflow: visible;
    visibility: visible;
    p {
      color: black;
    }
  }
`;

const sidebarWidth = 25;
// margin left to accommodate the vertical bar position fixed
export const GridDiv = styled.div`
  width: 100%;
  margin-left: ${sidebarWidth}px;
`;
export const SideBarDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20vh;
  width: ${sidebarWidth}px;
  height: 100%;
  ${(props) => `background-color: ${props.theme.palette.background.paper};`}
  position: fixed;
  top: 0;
  left: 0;
  overflow-x: scroll;
  scrollbar-width: none;
`;

export const SidebarIcon = styled.div<{
  topBarHeight: number;
}>`
  ${(props) =>
    props.topBarHeight ? `margin-top: ${props.topBarHeight}px;` : `;`}
  align-self: flex-start;
`;
export const LowerSidebarIcon = styled.div<{ readOnly?: boolean }>`
  align-self: flex-end;
  ${(props) =>
    props.readOnly
      ? `  display: flex;
          height: 100%;`
      : `;`}
`;

/** IDG */
export const IdgDiv = styled.div<{ patientHeaderHeight?: number }>`
  overflow: scroll;
  ${(props) => `background-color: ${props.theme.palette.background.paper};`}
  ${(props) => {
    const { dashboard } = props.theme.props;
    const { getFullSizeHeight } = dashboard;
    return `height: ${getFullSizeHeight(
      props.patientHeaderHeight,
      window.innerHeight,
    )}px;`;
  }}
`;

// style is in style.cs
// there is a min height as we don't want the print interface to vary in size
export const PrintInterfaceDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  /* No fixed min-height: allows compact layout so the dialog can fit without vertical scroll. */
  min-height: 0;
  min-width: 0;
`;
export const CalendarDiv = styled.div`
  display: flex;
  justify-content: space-around;
  min-width: 260px;
`;
export const SubmitDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.125rem 0.5rem;
`;
export const ModalDiv = styled.div<{
  show?: boolean;
  /** When set, overlay spans the full viewport including the fixed sidebar (default leaves 25px for ribbon). */
  $coverSidebar?: boolean;
}>`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.65);
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  max-height: -webkit-fill-available;
  ${(props) =>
    isIPad &&
    '@supports (-webkit-touch-callout:none){ height: -webkit-fill-available;}'}
  justify-content: center;
  position: fixed;
  transition: all 0.2s ease-in-out;
  width: 100%;
  z-index: 1000;
  margin-left: ${(props) => (props.$coverSidebar ? 0 : `${sidebarWidth}px`)};
  ${(props) => (props.show ? `visibility: visible` : `visibility: hidden;`)}
  ${(props) =>
    props.show ? `opacity: 1;` : `opacity: 0;`}
  flex-direction: row-reverse
`;

const getWidgetSpecs = (props: any) => {
  switch (props.name) {
    case DocLink:
      return `;`;
    default:
      return `box-shadow: 0 0px 5px rgba(255, 255, 255, 0.72);
              border: 1px solid rgba(255, 255, 255, 0.82);`;
  }
};
const getWidgetSize = (props: any) => {
  switch (props.name) {
    case Manifest:
      return `width: 80%;`;
    case CarePlanFrequency:
      return `width: 850px;`;
    case VisitSummary:
      return `width: 1150px;`;
    case VisitLog:
      return `width: 1150px;`;
    case Bereavement:
      return `width: 950px;`;
    case Incidents:
      return `width: 950px;`;
    default:
      return `width: 90%;`;
  }
};

const getSize = (props: any) => {
  switch (props.numberOpen) {
    case 1:
      return getWidgetSize(props);
    case 2:
      return `width: 45%;`;
    default:
      return `width: 45%;`;
  }
};
export const WidgetModal = styled.div<{
  numberOpen: number;
  topBarHeight: number;
  name?: string;
  index: number;
}>`
  background-image: linear-gradient(
    top,
    black,
    black 8%,
    transparent 8%,
    transparent 100%
  );
  background-image: -webkit-linear-gradient(
    top,
    black,
    black 8%,
    transparent 8%,
    transparent 100%
  );
  /* Changed this from overflow: hidden to test */
  ${(props) => (isIPad ? 'overflow: scroll;' : 'overflow: hidden;')}
  transform: scale(1);
  position: relative;
  transition: 0.2s ease-in-out all;
  margin-right: 25px;
  margin-left: 5px;
  animation: createBox 1s;
  @keyframes createBox {
    from {
      transform: scale(0.5);
    }
    to {
      transform: scale(1);
    }
  }
  ${(props) => getSize(props)}
  ${(props) => getWidgetSpecs(props)}
  ${(props) => {
    if (!isIPad) {
      if (props.topBarHeight) {
        /* the first 2 widgets open and margin-top */
        if (props.index < 2) {
          return props.topBarHeight < 80
            ? `margin-top: ${props.topBarHeight + 10}px;
               max-height: 90%;`
            : `margin-top: ${props.topBarHeight + 16}px;
               max-height: 78%;`;
        }
        return props.topBarHeight < 80
          ? `max-height: 90%;`
          : `max-height: 78%;`;
      }
      return `max-height: 95%;`;
    }
    if (isIPad) {
      if (props.topBarHeight) {
        /* the first 2 widgets open and margin-top */
        if (props.index < 2) {
          return props.topBarHeight < 80
            ? `margin-top: ${props.topBarHeight + 10}px;
               max-height: 85%;`
            : `margin-top: ${props.topBarHeight + 16}px;
               max-height: 78%;`;
        }
        return props.topBarHeight < 80
          ? `max-height: 85%;`
          : `max-height: 78%;`;
      }
      /* only 2 widgets open or not */
      return props.numberOpen < 3 ? `max-height: 95%;` : `max-height: 85%;`;
    }
    return `;`;
  }}

`;

// **** PRINT INTERFACE ****
// todo common-ui
export const PrintSelectionDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 0;
  border-bottom: solid 1px grey;
`;

export const PrintOptionsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 1px;
  padding-bottom: 1px;
  max-width: 19rem;
  min-width: 0;
  flex: 1 1 auto;
  padding-left: 0px;
`;

export const OptionsBox = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

export const PrintInterfaceHeader = styled.div`
  float: right;
  padding-right: 5px;
  font-size: 0.875rem;
  line-height: 1.35;
`;

export const SmallDiv = styled.div<{
  width: number;
  align?: string | null;
}>`
  width: ${(props) => `${props.width}px;`};
  ${(props) => (props.align ? `text-align: ${props.align}` : ``)}
  & * {
    font-size: 1rem;
  }
`;

export const TextDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  font-weight: 400;
  font-size: 1rem;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 5px;
`;

export const ExpansionDiv = styled.div`
  height: inherit;
  max-height: 86vh;
`;

export const ExpansionHeaderDiv = styled.div<{
  index: number;
}>`
  ${(props: any) =>
    props.index === 0
      ? `;`
      : `border-top: 1px solid ${props.theme.palette.background.default};`}
  ${(props: any) => {
    const { header } = props.theme.palette.background;
    return `background-color: ${header};
    border-bottom: 1px solid ${props.theme.palette.background.default};`;
  }}
  display: flex;
  width: 100%;
  min-height: 36px;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding-right: 10px !important;
`;

export const StandingOrdersInfoDiv = styled.div`
  @media print {
    overflow: visible !important;
    > p:first-of-type {
      margin-top: 0.5cm !important;
    }
    > p:nth-of-type(23n) {
      page-break-after: always;
    }
    > p {
      margin: 0.4cm;
      margin-top: 0.5cm;
    }
  }
  max-height: 60vh;
  overflow: auto;
  padding-left: 5px;
`;

export const TitleHeaderDiv = styled.div`
  ${(props: any) => {
    const { main } = props.theme.palette.primary;
    return `color: ${main};`;
  }}
  padding-left: 10px;
  display: flex;
  font-weight: 500;
  font-size: 14px;
  font-family: 'Muli', sans-serif;
`;

export const PrintDiv = styled.div`
  @media print {
    color: black;
    position: relative;
  }
  @page {
    size: portrait !important;
  }
`;

export const PRNDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  @media print {
    > * {
      display: block !important;
    }
  }
`;

export const PRNText = styled.div`
  @media print {
    padding-top: 0.5cm !important;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  ${(props: any) => {
    const { dark } = props.theme.palette.primary;
    return `background-color: ${dark} !important;`;
  }}
  ${(props: any) => {
    const { contrastPrimaryPaper } = props.theme.palette.text;
    return `color: ${contrastPrimaryPaper} !important;`;
  }}
`;
